import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { draftDialogDetailSelector } from "store/bailiff/task/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

export const FLOWS = {
  LOADING: "loading",
  EMPTY: "empty",
  HAS_TASK: "hasTask",
};

export const useFlow = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [flow, setFlow] = useState(FLOWS.LOADING);
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(draftDialogDetailSelector);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (detail === null) {
      setFlow(FLOWS.EMPTY);
    }

    if (detail) {
      setFlow(FLOWS.HAS_TASK);
    }
  }, [detail]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { flow };
};
